export default __webpack_public_path__ + "static/etd-dc98b53ad6d65475fa02c8a77d569ac7.png";